import { Branding,DisabledPrompt, Link, useModel, useParams} from "bcms-react";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import React from "react";
import Util from "classes/Util";
import "./styles.css";

/**
 * @function MenuPage
 * @return {React.Component}
 * @exported true
 * @description The main component for MenuPage
 */
export default function MenuPage(props) {
  const { branding } = useModel();
  const { options } = branding;
  const { menu } = useParams();
const pageMenu = {
    payTransfer: {
        title:"Pay & Transfer",
        class:"pay-transfer",
        data:[
              {
                "label":"Payments",
                "path":"/MenuPage/payments"
              },
              {
                "label":"Transfers",
                "path":"/transfers"
              },
            ]
      },
      payments: {
        title:"Menu",
        class:"payments",
        data:[
              {
                "label":"Pay Bills",
                "path":Util.inMabi ?"/rxpmw":"/payments"
              },
              {
                "label":"Pay my Loan",
                "path":"/transfers"
              },
              {
                "label":"Pay People with Zelle",
                "path":"/rxpmw"
              },
            ]
      }, changeProfile: {
        title:"Change Profile",
        class:"change-profile",
        data:[
              {
                "label":"Password",
                "path":"/password"
              },
              {
                "label":"Phone",
                "path":"/phoneNumber"
              },
              {
                "label":"Security Questions",
                "path":false
              },
              {
                "label":"Email",
                "path":"/email"
              },
              {
                "label":"User ID",
                "path":"/userId"
              },
            ]
      }

    }
  return (
    <PageContainer className={`menu-page ${menu} ${props.className}`}>
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text={pageMenu[menu].title} />         
            <MenuPageContent class={pageMenu[menu].class} data={pageMenu[menu].data}/>         
         
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}

/**
 * @function MenuPage
 * @return {React.Component}
 * @exported false
 * @description The default content for the profile page. 
 * Other bids may not use the same content, like the links.
 */
function MenuPageContent(props) {
  let links = props.data.map(function(link){
    if(link.path){
   return    <div className="flex-height link-item">
              <Link to={link.path}>{link.label}</Link>
            </div>
    }
    
   return <DisabledPrompt>
           <div className="flex-height link-item">
              <Link>{link.label}</Link>
            </div>
          </DisabledPrompt>

  })
  return (
    <div className={`flex-container flex-vertical menu-page-content ${props.class}`}>
     {links}     
    </div>
  );
}